module.exports = __webpack_public_path__ + "static/media/hamburger-icon.c275e518.svg";